package com.vizio.redwolf.auth.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class SwapOneOrAllDevicesRequestInfo(
    val setupCode: String,
    val allDevices: Boolean,
    val accessToken: String
)

@Serializable
@JsExport
internal data class SwapOneOrAllDevicesClientRequestInfo(
    val setupCode: String,
    val allDevices: Boolean
)

